<template>
    <div
        v-if="isComponentReady"
        class="l-ss-c-image-search-similar-wrapper">
        <div
            :class="{
                'l-ss-c-image-search-similar-wrapper-mask-hidden':
                    isShowAgeCheckPopup ||
                    store.state.ui.isCategoriesListVisible ||
                    showResultsMask ||
                    isFiltersOpened
            }"
            class="l-ss-c-image-search-similar-wrapper-mask"
            @mousedown="mousedownClose"
            @click.self="onClickOutside">
            <div
                :class="{
                    [`l-ss-c-search-popup-is-loading`]: isLoading,
                    ...wrapperClasses,
                }"
                class="l-ss-c-search-popup">
                <div
                    class="l-ss-c-search-popup-content-wrapper"
                    :class="{
                        'l-ss-c-search-popup-content-wrapper-right-angles': isContentVisible,
                        'l-ss-c-search-popup-content-wrapper-with-result': isResultsVisible && totalItemsCount
                    }">
                    <image-search-similar-results-wrapper
                        :has-query="hasQuery"
                        :has-results="hasResults"
                        :store="store"
                        :search-state="searchState"
                        :query="query"
                        :total-items-count="totalItemsCount"
                        :is-results-visible="isResultsVisible"
                        :is-filters-block-visible="isFiltersBlockVisible"
                        :request-categories="requestCategories"
                        :results-category-id="resultsCategoryId"
                        :error-text-search="errorTextSearch"
                        :has-filters="hasFilters"
                        :has-loaded-once="hasLoadedOnce"
                        :show-results-mask="showResultsMask"
                        :is-search-loading="isSearchLoading"
                        :loading-by-filters="loadingByFilters"
                        :limit="limit"
                        :search-response="searchResponse"
                        :search-request-id="searchRequestId"
                        :skip="skip"
                        :offer-templates="offerTemplates"
                        :filter-items="filterItems"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :is-show-sort="false"
                        :currency-in-offers="currencyInOffers"
                        :filter-values="filterValues"
                        :all-categories-tree="allCategoriesTree"
                        :search="search"
                        :is-show-signature="isShowSignature"
                        :adult-permission-confirmed="adultPermissionConfirmed"
                        v-on="imageSearchSimilarResultsWrapperEventListeners"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import RootComponentMixin from '../core/mixins/root-component';
    import SearchResultsMixin from '../core/mixins/search-results-mixin';
    import ImageSearchSimilarResultsWrapper from '@/core/components/image-search-similar-results/image-search-similar-results-wrapper.vue';
    import EventEmitterMixin from '../core/mixins/event-emitter';
    import {
        mapHandlers,
        commonOfferEventHandlers,
        commonSearchResultsWrapperEventHandlers,
    } from '@/core/mixins/event-emitter';

    export default {
        components: {
            ImageSearchSimilarResultsWrapper,
        },
        mixins: [
            EventEmitterMixin,
        ],
        provide: RootComponentMixin.provide,
        props: {
            ...RootComponentMixin.props,
            ...SearchResultsMixin.props,
            query: {
                type: String,
                default: '',
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
        },
        data() {
            return {
                isShowCompletions: false,
                wrapperClickTarget: null,
                typeWidget: 'image-search-similar',
            };
        },
        computed: {
            ...RootComponentMixin.computed,
            ...SearchResultsMixin.computed,
            openedPopup() {
                return this.store.state.ui.isImageSearchWidgetVisible &&
                    this.store.state.ui.isNameWidgetActive.toUpperCase() === this.$root.$options.customElement.nodeName.toUpperCase();
            },
            isShowAgeCheckPopup() {
                return this.store.state.ui.isShowAgeCheckPopup;
            },
            showResultsMask() {
                return this.$screen.isMobile && this.isShowCompletions;
            },
            isFiltersOpened() {
                return this.store.state.ui.isFiltersOpened;
            },
            isLoading() {
                return this.isSearchLoading || this.isCategoriesLoading;
            },
            isContentVisible() {
                return !!(this.store.state.ui.isCategoriesListVisible || !this.isResultsVisible);
            },
            allCategoriesTree() {
                return this.requestCategories ? this.requestCategories.categoriesTree : [];
            },
            imageSearchSimilarResultsWrapperEventListeners() {
                return {
                    ...mapHandlers(this, commonOfferEventHandlers),
                    ...mapHandlers(this, commonSearchResultsWrapperEventHandlers),
                    'navigate-category': this.handleNavigateCategory,
                    'page-reload': this.handlePageReload,
                    'click-close': this.clickClose,
                    'toggle-filters': this.toggleFilters,
                    'toggle-image-picker': args => this.onSearchInputAction('toggle-image-picker', args),
                    'add-to-cart': args => this.onSearchInputAction('add-to-cart', args),
                    'handle-search': args => this.onSearchInputAction('handle-search', args),
                };
            },
        },
        watch: {
            'store.state.ui.isCompletionsVisible': {
                handler(value) {
                    if (value && !this.isFocused && this.value) {
                        this.$refs.input.focus();
                        this.isFocused = true;
                    }
                },
            },
            'store.state.ui.isImageSearchVisible': {
                handler(value) {
                    if (!value) {
                        this.$emit('reset-position');
                    }
                },
            },
            'store.state.ui.isImageSearchLoader': {
                handler(value) {
                    this.$emit('loader-image', { value: value });
                },
            },

        },
        methods: {
            ...RootComponentMixin.methods,
            ...SearchResultsMixin.methods,
            onImageSearch(baseImage) {
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchWidgetVisible', value: false });
                this.$emit('search-image', { base64: baseImage });
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchWidgetVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
            },
            mousedownClose(event) {
                this.wrapperClickTarget = event.target;
            },
            onClickOutside(event) {
                if (this.wrapperClickTarget === event.target) {
                    this.handleCloseWidgetCommonActions();
                    this.closeWidgetClick('lossFocus', event);
                }
            },
            clickClose() {
                this.handleCloseWidgetCommonActions();
            },
            handleCloseWidgetCommonActions() {
                this.$emit('reset-query');
                this.$emit('search-popup-close');
            },
            closeWidgetClick(clickType, event) {
                this.$emit('close-widget-click', {
                    type: 'iwCloseSimilarPopup',
                    query: this.query,
                    customEventType: clickType,
                    event,
                });
            },
        },
    };
</script>
